module.exports = __webpack_public_path__ + "static/media/airConditioningIcon.02905ae9.svg";